export default __webpack_public_path__ + "media/images/admin/dashboard/GuideDialogImageIncomplete-d3184829e1ec51b699ea64a09d3c34db.png";